export default __webpack_public_path__ + "static/media/user.d9b6ed93.svg";